module.exports = __webpack_public_path__ + "img/poland.74a2c18a.svg";